module.exports = __webpack_public_path__ + "static/media/coupon.e5dff1fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/coupon.png
// module id = 932
// module chunks = 2